import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * Standard form action row: [Cancel] [Primary…]. Cancel always sits left of
 * the primary action(s), right-aligned as a group — never toggled in the
 * section header.
 */
export function FormFooter({
	onCancel,
	cancelLabel = "Cancel",
	cancelDisabled,
	children,
	className,
}: {
	onCancel?: () => void;
	cancelLabel?: string;
	cancelDisabled?: boolean;
	children?: ReactNode;
	className?: string;
}) {
	if (!onCancel && !children) {
		return null;
	}

	return (
		<div className={cn("flex items-center justify-end gap-2", className)}>
			{onCancel ? (
				<Button
					type="button"
					variant="outline"
					onClick={onCancel}
					disabled={cancelDisabled}
				>
					{cancelLabel}
				</Button>
			) : null}
			{children}
		</div>
	);
}